module.exports = __webpack_public_path__ + "img/1728544869535-Screenshot_10-10-2024_152052_www.instagram.com.jpeg.2d3c7c46.webp";